<div class="form">
  <ldw-settings-form [captionWidth]="230" [settings]="settings"></ldw-settings-form>
</div>
@if (canChangePassword$ | async) {
  <button
    mat-stroked-button
    class="change-pwd-btn mat-stroked-button default-background-stroked-button"
    (click)="goToChangePassword()"
    >
    {{ 'SETTINGS.CHANGEPASSWORD' | translate }}
  </button>
}
